import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { EnrollmentFilter } from '../../lib/types/models/enrollment/enrollment-filter'
import { EnrollmentCenter } from '../../lib/types/models/enrollment-center/enrollment-center'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterEnrollments(
  centerId: number,
  input: PaginationRequest<EnrollmentFilter> = {}
) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest<EnrollmentFilter>>(
        constructApiUrl(API.centers.getEnrollments.url, { id: centerId }),
        input
      )
    )
    .get<PaginationResponse<EnrollmentCenter>>()
}
